import React from 'react';
import { Button } from '../../../../Button';

export const ShowMore = ({ length, amount, setPage }) => {
  const isShowButton = (lengthCard, amountCard) =>
    lengthCard > amountCard;

  return (
    isShowButton(length, amount) && (
      <Button
        view="textResult"
        onClick={() => {
          setPage();
        }}
        fullWidth
        topGap
      >
        ПОКАЗАТЬ ЕЩЕ
      </Button>
    )
  );
};
